import styled from 'styled-components'

// https://stackoverflow.com/questions/31835164/how-do-i-fix-a-flexbox-sticky-footer-in-ie11

export default styled.div`
  display: flex;
  flex-flow: column nowrap;
`
